"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classTransformer_1 = require("../classTransformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
const Document_1 = __importDefault(require("./Document"));
const EAnchoringStatus_1 = __importDefault(require("./EAnchoringStatus"));
const EBlockchainName_1 = __importDefault(require("./EBlockchainName"));
class DocumentAnchor extends Resource_1.default {
}
exports.default = DocumentAnchor;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Document is required" }),
    (0, classTransformer_1.Type)(() => Document_1.default),
    __metadata("design:type", Document_1.default)
], DocumentAnchor.prototype, "document", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "document_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ message: "File hash is required" }),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "file_hash", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(EBlockchainName_1.default),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "blockchain", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(EAnchoringStatus_1.default),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DocumentAnchor.prototype, "anchor_nb_try", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], DocumentAnchor.prototype, "anchored_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "anchored_by_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "tx_id", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "tx_link", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "tx_hash", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DocumentAnchor.prototype, "anchor_job_id", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DocumentAnchor.prototype, "block_height", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], DocumentAnchor.prototype, "block_time", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], DocumentAnchor.prototype, "created_at", void 0);
